let sdkPromise: Promise<void> | null = null;

export function loadFacebookSdk(appId: string, apiVersion: string): Promise<void> {
  if (window.FB) return Promise.resolve();
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise<void>((resolve, reject) => {
    window.fbAsyncInit = () => {
      window.FB.init({ appId, cookie: true, xfbml: true, version: apiVersion });
      resolve();
    };
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      // Reset so a retry (e.g. after disabling an ad blocker) re-attempts the load.
      sdkPromise = null;
      script.remove();
      reject(new Error('Facebook SDK failed to load'));
    };
    document.head.appendChild(script);
  });

  return sdkPromise;
}
